import { BoxProps } from '@withjoy/joykit';
import React from 'react';
import { SearchInputBar } from '../CatalogSearchBar/components/SearchInputBar';
import { useSearchBar } from '../CatalogSearchBar/hooks/useSearchBar';

interface CatalogSearchBarInputProps
  extends Readonly<
    {
      placeholder?: string;
    } & Omit<BoxProps, '__css'>
  > {}

export const CatalogSearchBarInput = (props: CatalogSearchBarInputProps) => {
  const { clearSearchText, handleOnChange, handleOnFocus, handleOnKeyDown, handleOnSubmit, searchText } = useSearchBar();
  return (
    <SearchInputBar
      {...props}
      clearSearchText={clearSearchText}
      handleOnFocus={handleOnFocus}
      handleOnChange={handleOnChange}
      handleOnKeyDown={handleOnKeyDown}
      handleOnSubmit={handleOnSubmit}
      searchText={searchText}
    />
  );
};
